module.exports = __webpack_public_path__ + "img/the-perfect-storm.46d67d63.jpg";